export const properties = {
    RESOURCE: 'solicitantesPuntosHistorico',
    urlSolicitantesPuntosHistorico: '/findByDni/'
}
